import axiosInstance, { errorHandler } from "./api";

const getRolesOptions = axios => () => {
  return axios
    .get(`/api/users/role-authorities`)
    .then(({ data }) => data)
    .catch(errorHandler);
};
const getActivityOptions = axios => () => {
  return axios
    .get(`/audit-emitter/api/v1/logs/activities`)
    .then(({ data }) => data)
    .catch(errorHandler);
};
const listAuditLogs = axios => ({
  page = 0,
  size = 10,
  filter = "",
  sort = "logDateTime,Desc",
  dateFrom,
  dateTo,
  activities = "",
  roles = "",
}) => {
  return axios
    .get(`/audit-emitter/api/v1/logs`, {
      params: {
        page,
        size,
        roles,
        dateFrom,
        dateTo,
        sort,
        q: filter,
        activities,
      },
    })
    .then(({ data }) => data)
    .catch(errorHandler);
};

export default {
  getActivityOptions: getActivityOptions(axiosInstance),
  getRolesOptions: getRolesOptions(axiosInstance),
  listAuditLogs: listAuditLogs(axiosInstance),
};
